import { UserRole } from "../api/generated"

export const QUEUE_QUERY_KEY = ["invoice_queue"]
export const QUEUE_DROPDOWN_KEY = ["invoice_dropdown_queue"]
export const QUEUE_STATISTICS_QUERY_KEY = "invoice_queue_statistics"
export const INVOICE_DETAIL_QUERY_KEY = ["invoice_detail"]
export const PDF_FILE_QUERY_KEY = ["pdf_file"]
export const INVOICE_HISTORY_QUERY_KEY = ["invoice_history"]
export const EMAIL_ATTACHMENT_QUERY_KEY = ["email_attachment"]
export const PURCHASE_ORDERS_QUERY_KEY = ["purchase_orders"]
export const INVOICE_QUEUE_LIST_QUERY_KEY = ["invoice_queue_list"]
export const PURCHASE_ORDER_DETAIL_QUERY_KEY = ["purchase_order_detail"]
export const REJECT_INVOICE_QUERY_KEY = ["reject_invoice"]
export const TAX_CODES_QUERY_KEY = "tax_codes"
export const INVOICE_GET_IDS_QUERY_KEY=["invoice_get_ids"]

export const USER_ROLE_LABEL_MAPPINGS = {
  [UserRole.SYSTEM_ADMIN]: "System Admin",
  [UserRole.TEAM_LEAD]: "Team Lead",
  [UserRole.USER]: "Invoice Processor",
  [UserRole.SERVICE]: "Service Account",
  [UserRole.CLIENT_ADMIN]: "Client Admin",
}

export const OPCOS_THAT_BYPASS_TAX_VALIDATION =
  import.meta.env.VITE_OPCOS_THAT_BYPASS_TAX_VALIDATION?.split(",") ?? [
    "central",
  ]
